module.exports = __webpack_public_path__ + "media/images/banks/vn-sacombank-a866beeee565101b47d970407845856f.png";